export const memoryStorage = (() => {
    const state = new Map();

    return {
        get(key) {
            return state.get(key);
        },

        set(key, value) {
            state.set(key, value);
            return this;
        },

        has(key) {
            return state.has(key);
        },

        delete(key) {
            return state.delete(key);
        },

        clear() {
            state.clear();
        }
    };
})();